import React from "react";
import { Box, Typography, Button, Paper, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAuthStore from "../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../Configurations/Urls";
import { clearClientPreferredOrganizationId } from "../Utils/clientActiveOrganization";
import { getLoginPathAfterLogout } from "../Utils/studentPortalPath";

export default function NotAllowed() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      if (token) {
        await axios.get(`${MAIN_URL}/api/auth/logout`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {
      // Continue local logout even if API call fails.
    }
    const loginPath = getLoginPathAfterLogout(useAuthStore.getState().userData);
    logout();
    localStorage.removeItem("token");
    clearClientPreferredOrganizationId();
    navigate(loginPath, { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 480,
          textAlign: "center",
          borderRadius: 3,
        }}
      >
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
          Access Denied
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, opacity: 0.8 }}>
          You don&apos;t have permission to view this page. If you think this is
          a mistake, please contact your administrator.
        </Typography>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#115293",
              },
            }}
          >
            Go to Dashboard
          </Button>
          <Button variant="outlined" color="error" onClick={handleLogout}>
            Logout
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
